import { render, staticRenderFns } from "./Subjects.vue?vue&type=template&id=f1bd119a"
import script from "./Subjects.vue?vue&type=script&lang=js"
export * from "./Subjects.vue?vue&type=script&lang=js"
import style0 from "./Subjects.vue?vue&type=style&index=0&id=f1bd119a&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dusanvelickovic/Herd/bookybook/bookybook-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f1bd119a')) {
      api.createRecord('f1bd119a', component.options)
    } else {
      api.reload('f1bd119a', component.options)
    }
    module.hot.accept("./Subjects.vue?vue&type=template&id=f1bd119a", function () {
      api.rerender('f1bd119a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/Subjects.vue"
export default component.exports